export default __webpack_public_path__ + "static/media/BLUU-car-booking-01.872b069a.svg";